import React from 'react'

import AttachmentButtonDownload from "../../../../files/attachment-view/blocks/buttons/download"
import AttachmentButtonOpenNewWindow from "../../../../files/attachment-view/blocks/buttons/open-new-window"
import {ControlButtonSize} from "../../../../buttons/control-button/@types";
import ControlButtonStandard from "../../../../buttons/control-button/control-button-standard";
import AttachmentButtonRemove from "../../../../files/attachment-view/blocks/buttons/remove";

export enum AlignType {
    LEFT    = 'left',
    CENTER  = 'center',
    RIGHT   = 'right'
}

type Props = {
    alignment           : AlignType
    attachment?         : any

    onChangeAlignment   : {(id: AlignType):void}
    onRemove            : {():void}

    className?          : string
}

export default class AlignSelector extends React.Component<Props> {

    onChangeAlignment = (id: AlignType) => {
        if (this.props.onChangeAlignment) this.props.onChangeAlignment(id)
    }

    renderItem(item: any) {
        const iconClasses = Classes('fs-12', item.icon)

        return <ControlButtonStandard key           = {item.id}
                                      className     = "m-r-2"
                                      size          = {ControlButtonSize.SIZE_28}
                                      isSelected    = {item.id === this.props.alignment}
                                      iconClass     = {iconClasses}
                                      onClick       = {!!item.onClick ? item.onClick : this.onChangeAlignment.bind(this,item.id)}/>
    }

    onDeleteClick = () => {
        // console.log(".onDeleteClick()")

        // remove from message
        this.props.onRemove()

        // then delete
        this.props.attachment?.refAttachmentManager.current.onRemove(this.props.attachment)
    }

    render() {
        const autoDistributionOptions = [
            {id: AlignType.LEFT,    icon: 'option-icon i5-allign-image-left'},
            {id: AlignType.CENTER,  icon: 'option-icon i5-allign-image-center'},
            {id: AlignType.RIGHT,   icon: 'option-icon i5-allign-image-right'}
        ]

        const {attachment} = this.props

        let renderMode = attachment ? this.props.attachment.renderMode : null

        switch (renderMode) {
            case 'notes-edit':
                return (
                    <div className={Classes("align-selector", this.props.className)}>
                        <div className="align-options">
                            {autoDistributionOptions.map(item=>this.renderItem(item))}
                        </div>

                        {attachment?.isSaved &&
                            <>
                                <AttachmentButtonDownload className     = "m-l-10 m-r-8"
                                                          attachment    = {this.props.attachment}/>
                                <AttachmentButtonOpenNewWindow className    = "m-r-8"
                                                               attachment   = {this.props.attachment} />
                            </>}

                        <AttachmentButtonRemove onClick={this.onDeleteClick}/>
                    </div>
                )

            default:
                return (
                    <div className={Classes("align-selector", this.props.className)}>
                        <div className="align-options">
                            {autoDistributionOptions.map(item=>this.renderItem(item))}
                        </div>

                        <div className="remove-option">
                            <AttachmentButtonRemove onClick={this.props.onRemove}/>
                        </div>
                    </div>
                )
        }
    }
}